import { AgenciaService } from 'src/app/services/geral/agencia.service';
import { Agencia } from 'src/app/model/geral/agencia';
import { Component, Injector, OnInit } from '@angular/core';
import { GeralListaModule } from './gerallista.module';
import { ListaSimplesGenerica } from '../../generic/listagenerica/listasimplesgenerica';

@Component({
  selector: 'app-lista-agencia',
  templateUrl: '../../generic/listagenerica/listasimples.component.html',
  styleUrls: [ '../../generic/listagenerica/listasimples.component.css']
})

export class ListaAgenciaComponent extends ListaSimplesGenerica<Agencia> implements OnInit {

  override obj = new Agencia();

  constructor(
    injectorObj: Injector,
    api: AgenciaService) 
  {
    super(injectorObj, api);
  }

  override ngOnInit(): void {
    super.ngOnInit();
  }

  override dataExtraList(res: any) {
}

  override getColorCell(valor: any) {   
  }

}
